import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { routerReducer as routing, routerMiddleware } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';

import app from './App/reducer';
import precache from './Precache/reducer';
import staticPages from './StaticPages/reducer';
import post from './Post/reducer';
import posts from './Posts/reducer';
import postsSearch from './PostsSearch/reducer';
import postTags from './PostTags/reducer';
import vacancies from './Vacancies/reducer';
import successStories from './SuccessStories/reducer';
import programs from './Programs/reducer';
import examples from './Examples/reducer';
import chart from './Chart/reducer';

import investors from './InvestorSection/reducer';


import createApiMiddleware from './middleware/api';
import precacheMiddleware from './middleware/precache';

const rootReducer = combineReducers({
  app,
  precache,
  staticPages,
  post,
  posts,
  postsSearch,
  postTags,
  vacancies,
  successStories,
  programs,
  examples,
  chart,
  investors,

  routing
});

function configureStore(history, initialState) {
  const middleware = [
    precacheMiddleware(),
    createApiMiddleware(),
    routerMiddleware(history),
    thunkMiddleware
  ];

  const createStoreWithMiddleware = compose(
    applyMiddleware(...middleware),
    typeof window !== 'undefined' && window.devToolsExtension ? window.devToolsExtension() : f => f
  )(createStore);

  return createStoreWithMiddleware(rootReducer, initialState);
}

export default configureStore;



// WEBPACK FOOTER //
// ./src/redux/configureStore.js